/* eslint-disable */
// VENDORED unchanged from learning_brain_poc/rhs4_checks.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// Chat v4 right-hand side: 'Possible causes and checks', every cause seen in the chat with the state of each of its checks
// (Confirmed / Not confirmed / Checking now / Not checked yet), and the button that overrides the diagnosis onto one of them.
// window.Rhs4Checks = {render(state, deps)}; deps = {h, cleanLabel, section, muted, fire, pct, plural}. All text goes in as text nodes.
(function () {
  'use strict';

  const TITLE = 'Possible causes and checks';
  const MARK = {done: '✓', failed: '✗', current: '▶', pending: '○'};
  const MARK_WORD = {done: 'Confirmed', failed: 'Not confirmed', current: 'Checking now', pending: 'Not checked yet'};
  const STATE_TAG = {leading: 'Current', open: 'Open', ruled_out: 'Ruled out', set_aside: 'Set aside', fix_failed: 'Fix did not work'};
  const EMPTY = 'The possible causes and their checks appear here once the problem is described.';
  const NO_CHECKS = 'No checks are stored for this cause.';
  const INTRO = 'Every possible cause seen in this chat stays here with its checks, also when it is ruled out or set aside.';
  const OVERRIDE = 'Investigate this cause';
  const OVERRIDE_TIP = 'Continue on this cause even if it was ruled out. Your earlier answers stay.';
  const UNDO = 'Undo override', UNDO_TIP = 'Put the ruled-out causes back as they were before the override';
  const OVERRIDDEN = 'You chose this';

  function checkList(pc, d) {
    if (!pc.steps.length) return d.muted(NO_CHECKS);
    return d.h('ol', {class: 'v4-pc-checks'}, pc.steps.map(s => d.h('li', {class: 'v4-step v4-step-' + s.status},
      d.h('span', {class: 'v4-mark', 'aria-label': MARK_WORD[s.status]}, MARK[s.status]),
      d.h('div', null, d.h('div', {class: 'v4-step-text'}, d.cleanLabel(s.text)), d.h('div', {class: 'v4-step-find'}, MARK_WORD[s.status])))));
  }

  function row(pc, state, d) {
    const name = d.cleanLabel(pc.label) || 'A possible cause', mine = state.overridePid === pc.pid;
    const showPct = pc.current && pc.state !== 'ruled_out' && typeof pc.post === 'number';
    const btn = pc.state !== 'leading' && !mine
      ? d.h('button', {type: 'button', class: 'v4-small v4-override', title: OVERRIDE_TIP, 'aria-label': OVERRIDE + ': ' + name, disabled: !state.canOverride,
        onclick: () => d.fire('onOverride', pc.pid)}, OVERRIDE) : null;
    return d.h('li', {class: 'v4-pc v4-pc-' + pc.state, 'data-pid': pc.pid},
      d.h('div', {class: 'v4-row-head'}, d.h('span', {class: 'v4-row-name'}, name), d.h('span', {class: 'v4-tag v4-pc-tag'}, STATE_TAG[pc.state]),
        mine ? d.h('span', {class: 'v4-tag'}, OVERRIDDEN) : null, showPct ? d.h('span', {class: 'v4-pct'}, d.pct(pc.post) + '%') : null, btn),
      checkList(pc, d));
  }

  function render(state, d) {
    const rows = state.pcList || [];
    const undo = state.overrideUndo
      ? d.h('div', {class: 'v4-actions'}, d.h('button', {type: 'button', class: 'v4-small', title: UNDO_TIP, disabled: !state.canOverride,
        onclick: () => d.fire('onUndoOverride')}, UNDO)) : null;
    const body = rows.length ? d.h('div', null, d.muted(INTRO), undo, d.h('ul', {class: 'v4-pcs'}, rows.map(pc => row(pc, state, d)))) : d.muted(EMPTY);
    return d.section('pcs', TITLE, body, {count: rows.length || undefined, open: true});
  }

  window.Rhs4Checks = {render, MARK, MARK_WORD};
})();
